<div
    [ngClass]="forOriginOrDestination != 'multiple-destination' ? 'form-group col-md-12 p-0' : 'form-group col-md-12 p-0 mb-0'">
    <div class="d-flex justify-content-end align-items-center flex-end flex-wrap">
        <div class="col-sm-12 col-xs-12 d-flex justify-content-between column-gap-5 py-3 fill-width-available">
          <label class="d-flex align-items-center column-gap-10 mb-0"
                 *ngIf="isTbdVisible"
          >
            <input class="mt-0 checkbox"
                   type="checkbox"
                   [(ngModel)]="includeTBD"
                   (change)="onTbdChange()"
                   [disabled]="selectedAddressType"
            >
            <span>TBD</span>
          </label>
          <div class="d-flex justify-content-end column-gap-5 py-3 fill-width-available">
            <label class="d-flex align-items-center column-gap-10 mb-0" id="publicAddress">
              <input type="radio"
                     class="m-0"
                     id="public_{{dropdownId}}"
                     name="AddressType_{{dropdownId}}"
                     [disabled]="includeTBD"
                     value="public"
                     [(ngModel)]="selectedAddressType" (change)="updateAddressList(); clearSelectedAddress()"
              >
              <span>Public</span>
            </label>
            <label class="d-flex align-items-center column-gap-10 mb-0" id="privateAddress">
              <input type="radio"
                     class="m-0"
                     id="private_{{dropdownId}}"
                     name="AddressType_{{dropdownId}}"
                     value="private"
                     [disabled]="includeTBD"
                     [(ngModel)]="selectedAddressType" (change)="updateAddressList(); clearSelectedAddress()"
              >
              <span>Private</span>
            </label>
            <label class="d-flex align-items-center column-gap-10 mb-0 pr-2" id="airportAddress">
              <input type="radio"
                     class="m-0"
                     id="airport_{{dropdownId}}"
                     name="AddressType_{{dropdownId}}"
                     value="airport"
                     [disabled]="includeTBD"
                     [attr.data-testid]="'airport-address-radio-' + dropdownId"
                     [(ngModel)]="selectedAddressType" (change)="updateAddressList(); clearSelectedAddress()"
              >
              <span>Airport</span>
            </label>
          </div>
        </div>
        <div
            [ngClass]="forSRPageOrItinerary == 'SR-Page' ? (forOriginOrDestination != 'multiple-destination' ? 'col-xs-12 dropdown-width-sr-page' : 'flex-grow-1') : 'col-xs-12 dropdown-width-itinerary-page pl-0'">
            <div *ngIf="selectedAddressType == 'airport'" class="col-sm-12 col-xs-12 px-0 background-white">
                <ng-multiselect-dropdown-angular7 [settings]="airportCodeDropdownSettings"
                                                  [data]="airportCodeList"
                                                  [(ngModel)]="selectedAirportCodes"
                                                  [attr.data-testid]="'airportCodes_' + dropdownId"
                                                  (ngModelChange)="updateAddressList()"
                                                  name="airportCodes_{{dropdownId}}"
                                                  id="airportCodes_{{dropdownId}}"
                                                  placeholder="Select Airport Code"
                                                  (onSelect)="clearSelectedAddress()"
                ></ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
</div>
